import { BorderedBox } from "../components";
import { Row, Col, TabPane } from "reactstrap";
import { ProtectedImg, CustomAlert } from "components";
import {
	imageModalReducerActions,
	useImageModalContext,
} from "contexts/imageModal";
import { ImageUploadv2 } from "components/CustomUpload/ImageUploadv2";
import { useFieldArray } from "react-hook-form";
import { FiX } from "react-icons/fi";
import { useReducer, useRef } from "react";
import {
	confirmationModalInitialState,
	confirmationModalReducer,
	confirmationModalReducerActions,
} from "./reducers";
import { imageTypes } from "../constants";

export const Classwork = ({
	studentRecord: { lessonFiles, studentReportApproved },
	control,
	canEdit = false,
	editable,
}) => {
	const fileInputRef = useRef(null);
	const {
		fields: classworkPhotos,
		remove,
		append,
	} = useFieldArray({
		control,
		name: "classworkPhotos",
	});

	const { dispatch: imageModalDispatch } = useImageModalContext();

	const [confirmationModalProps, confirmationModalDispatch] = useReducer(
		confirmationModalReducer,
		confirmationModalInitialState
	);

	const triggerConfirmationModal = (index) => () => {
		confirmationModalDispatch({
			type: confirmationModalReducerActions.OPEN,
			payload: index,
		});
	};

	const closeConfirmationModal = () =>
		confirmationModalDispatch({
			type: confirmationModalReducerActions.CLOSE,
		});

	const submitConfirmationModal = (index) => () => {
		remove(index);
		confirmationModalDispatch({
			type: confirmationModalReducerActions.CLOSE,
		});
	};

	return (
		<TabPane tabId={2} key={2}>
			<Row>
				<CustomAlert
					show={confirmationModalProps.show}
					hideModal={closeConfirmationModal}
					title="Confirmation"
					description={
						<span className="text-warning">Delete Classwork?</span>
					}
					submitButtonText="Delete"
					submitModal={submitConfirmationModal(
						confirmationModalProps.indexToDelete
					)}
					fitToParent={true}
				/>
				<Col sm="12">
					<BorderedBox className="align-items-center">
						{classworkPhotos?.length ? (
							classworkPhotos?.map((classwork, index) => (
								<div
									className="col-6 col-sm-4 col-md-3 col-lg-2"
									key={classwork.id}
								>
									{(canEdit || editable) &&
										!studentReportApproved && (
											<FiX
												onClick={triggerConfirmationModal(
													index
												)}
												style={{ cursor: "pointer" }}
												className="text-danger"
											/>
										)}
									<ProtectedImg
										src={
											classwork.filepath || classwork.data
										}
										className="img-fluid rounded"
										onClick={() =>
											imageModalDispatch({
												type: imageModalReducerActions.SHOW,
												payload: classwork.filepath,
											})
										}
									/>
								</div>
							))
						) : (
							<div className="ml-2 d-flex align-items-center">
								No classwork photos
							</div>
						)}
						{(canEdit || editable) && !studentReportApproved && (
							<ImageUploadv2
								fileInputRef={fileInputRef}
								setValue={(_, imgURI) =>
									append({
										new: true,
										type: imageTypes.CLASSWORK,
										data: imgURI,
									})
								}
								labelText="Click to upload"
								disableImgGallery={true}
								marginClass="m-3"
							/>
						)}
					</BorderedBox>
				</Col>
			</Row>
		</TabPane>
	);
};
